import React from 'react'
import { useLocation } from 'react-router-dom'
import Header from './Header'
import Footer from './Footer'

function Layout({ children }) {
  const location = useLocation()
  const isActionsDashboard = location.pathname === '/dashboard/actions'
  const isMainDashboard = location.pathname === '/'
  const isShareManagement = location.pathname === '/dashboard/shares'
  
  // For actions dashboard, main dashboard, and share management, use full width without constraints
  if (isActionsDashboard || isMainDashboard || isShareManagement) {
    return (
      <div className="min-h-screen flex flex-col">
        <Header />
        <main className="flex-1">
          {children}
        </main>
        <Footer />
      </div>
    )
  }
  
  // Default layout with container constraints for other pages
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      
      <main className="flex-1 container mx-auto px-4 py-8 max-w-6xl">
        {children}
      </main>
      
      <Footer />
    </div>
  )
}

export default Layout